import { memo } from 'react';
import { default as ReactGA4 } from 'react-ga4';
import cn from 'classnames';
import { ITag } from 'src/interface';
import { Element, RouterLink, Title } from 'src/components';

interface IProps {
    items: ITag[];
}

export function ContentTagSection(props: IProps) {
    const { items = [] } = props;

    return (
        <>
            <Element className={'mb-[30px]'}>
                <Title
                    className={cn(
                        'text-[14px] leading-[1] uppercase',
                        'font-semibold',
                        'mb-[12px]',
                    )}
                >
                    Tìm nhanh
                </Title>
                <Element className={'flex flex-wrap gap-x-[4px] gap-y-[8px]'}>
                    {items.slice(0, 8).map((item: ITag, index: number) => {
                        const handleClick = () => {
                            ReactGA4.event({
                                category: 'mobile_search',
                                action: 'clickQuickSearch',
                            });
                        };
                        return (
                            <RouterLink
                                to={item.url}
                                className={cn(
                                    'flex items-center justify-center',
                                    'text-[13px] leading-[1] text-black',
                                    'h-[32px]',
                                    'px-[16px]',
                                    'rounded-full',
                                    'bg-white',
                                    'border border-solid border-[#D9D9D9]',
                                )}
                                key={index}
                                onClick={handleClick}
                            >
                                {item.name}
                            </RouterLink>
                        );
                    })}
                </Element>
            </Element>
        </>
    );
}

export default memo(ContentTagSection);
